var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"thumb-wrap"},_vm._l((_vm.thumbList),function(item,index){return _c('img',{key:index,attrs:{"src":_vm.$publicData.ossUrl+item,"alt":""}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }